module.exports = __webpack_public_path__ + "static/media/SignOffIcon.b422bfd9.svg";